import { Ticket, OperationType } from "./Entity";

export class Transfer extends Ticket {
  // Dados Carteira

  portfolioName: string = null;
  portfolioDocument: string = null;
  portfolioBank: string = null;
  portfolioBranch: string = null;
  portfolioAccount: string = null;
  portfolioFundId: number = null;
  portfolioFundAccountId: number = null;

  // Dados da Operação

  operationTypeId: OperationType = null;
  operationValue: number = null;
  settlementDate: Date = null;

  receiverName: string = null;
  receiverDocument: string = null;
  receiverBank: string = null;
  receiverBranch: string = null;
  receiverAccount: string = null;
  receiverFundId: number = null;
  receiverFundAccountId: number = null;

  annotations: string = null;

  transferStatusDescription: string = null;

  constructor() {
    super();
  }
}
